module.exports = __webpack_public_path__ + "img/Lizzy.6a912338.png";